<p-confirmDialog [closeOnEscape]="false" [closable]="false" width="400"></p-confirmDialog>